import createRestfulModule from './restful-module'
import { actionClient } from '@/api'

export default createRestfulModule({

  state: {
    path: 'member/personal/address', // 资源路径
    defaultRels: [], // 默认需要的关联数据
  },
  
  actions: {
    async getConsignee() {
      return await actionClient.get('member/personal/consignee')
    },
    async getRegion({commit}) {
      const res = await actionClient.get('regions')
      return res
    }
  },

})
